module.exports = __webpack_public_path__ + "images/GetValue.a1cf4af21be22a43406746931d28d838.png";